import { ICategory } from '@type/index';
export interface IProduct {
  _id?: string;
  images: string[];
  name: string;
  description?: string;
  categoryId: string;
  category?: ICategory;
  defaultPrice: number;
  unitName: EUnit;
  tax: number;
  suppliers?: ISupplierInfo[];
  slug?: string;
  finalPrice?: number;
  isRetailAvailable?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  isDelete?: boolean;
  code: string;
}

export interface IProductCart extends IProduct {
  quantity?: number;
}

export enum EUnit {
  KG = 'kg',
  G = 'gam',
  L = 'l',
  ML = 'ml',
  BOX = 'box',
  PACK = 'pack',
  BAG = 'bag',
  BOTTLE = 'bottle',
  JAR = 'jar',
  TUBE = 'tube',
  PIECE = 'piece',
  PAIR = 'pair',
  CAN = 'can',
  BUNDLE = 'bundle',
  FRUIT = 'fruit',
  UNIT = 'unit',
  MULTIPACK = 'multipack',
  SLICE = 'slice',
  BLISTER = 'blister',
  BUNCH = 'bunch',
  TRAY = 'tray',
  ROLL = 'roll',
  STACK = 'stack',
  VEGETABLE_BUNCH = 'vegetable_bunch',
  PILL = 'pill',
  CRATE = 'crate',
  CYLINDER = 'cylinder',
  SPINACH = 'spinach',
  SET = 'set',
  TREE = 'tree',
  BALL = 'ball',
}

export const EUnitDisplay: Record<EUnit, string> = {
  [EUnit.KG]: 'kg',
  [EUnit.G]: 'g',
  [EUnit.L]: 'l',
  [EUnit.ML]: 'ml',
  [EUnit.BOX]: 'hộp',
  [EUnit.PACK]: 'gói',
  [EUnit.BAG]: 'túi',
  [EUnit.BOTTLE]: 'chai',
  [EUnit.JAR]: 'hũ',
  [EUnit.TUBE]: 'ống',
  [EUnit.PIECE]: 'cái',
  [EUnit.PAIR]: 'cặp',
  [EUnit.CAN]: 'lon',
  [EUnit.BUNDLE]: 'bó',
  [EUnit.FRUIT]: 'trái',
  [EUnit.UNIT]: 'con',
  [EUnit.MULTIPACK]: 'lốc',
  [EUnit.SLICE]: 'lát',
  [EUnit.BLISTER]: 'vĩ',
  [EUnit.BUNCH]: 'nải',
  [EUnit.TRAY]: 'khay',
  [EUnit.ROLL]: 'cuộn',
  [EUnit.STACK]: 'xấp',
  [EUnit.VEGETABLE_BUNCH]: 'ky',
  [EUnit.PILL]: 'viên',
  [EUnit.CRATE]: 'thùng',
  [EUnit.CYLINDER]: 'bình',
  [EUnit.SPINACH]: 'bó',
  [EUnit.SET]: 'bộ',
  [EUnit.TREE]: 'cây',
  [EUnit.BALL]: 'quả',
};

export interface ISupplierInfo {
  supplierId: string;
  price: number;
  quantity: number;
}

export interface IProductInfo {
  icon: string;
  title: string;
  value: string;
}

export interface IProductFilters {
  category?: string;
  categories?: string[];
  subCategories?: string[];
  city?: string;
  direction?: string;
  order?: string;
  sort?: string;
  keyword?: string;
  minPrice?: number;
  maxPrice?: number;
}
export interface IProductFilter {
  filters?: IProductFilters;
  page?: number;
  limit?: number;
  sort?: string;
  order?: string;
  keyword?: string;
  cartItems?: { productId: string; quantity: number }[];
}

export enum ESortOrder {
  Asc = 'asc',
  Desc = 'desc',
}
